import { render, staticRenderFns } from "./MergedInvoice.vue?vue&type=template&id=0bac13c4&scoped=true"
import script from "./MergedInvoice.vue?vue&type=script&lang=js"
export * from "./MergedInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac13c4",
  null
  
)

export default component.exports